import FolderTreeType from '../store/schema/FolderTreeType';
import { updateUserConfigurationService } from 'owa-session-store/lib/services/updateUserConfigurationService';
import { action } from 'satcheljs/lib/legacy';
import { updateUserConfiguration } from 'owa-session-store/lib/actions/updateUserConfiguration';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Toggle the expansion of folder or favorite tree and update both local and server user config
 */
export default action('toggleFolderTreeExpansion')((folderTreeType: FolderTreeType) => {
    let dictionaryKey: any;
    let dictionaryValue: string;
    let newValue = null;
    const userOptions = getUserConfiguration().UserOptions;

    if (folderTreeType === FolderTreeType.PrimaryFolderTree) {
        dictionaryKey = 'IsMailRootFolderTreeCollapsed';
        newValue = !userOptions.IsMailRootFolderTreeCollapsed;
        dictionaryValue = String(newValue);
    } else {
        dictionaryKey = 'IsFavoritesFolderTreeCollapsed';
        newValue = !userOptions.IsFavoritesFolderTreeCollapsed;
        dictionaryValue = String(newValue);
    }

    updateUserConfiguration(userConfig => {
        userConfig.UserOptions[dictionaryKey] = newValue;
    });

    updateUserConfigurationService(
        [
            {
                key: dictionaryKey,
                valuetype: 'Boolean',
                value: [dictionaryValue],
            },
        ],
        'OWA.UserOptions'
    );
});
